export const space = Array.from(Array(100).keys()).map(x => x * 6)
